<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>Spelling Bee World Cup拼词世界杯</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleToClick">
            <el-tab-pane label="报名审核信息" name="2">
                 <!-- 筛选 -->
                <!-- <el-card style="margin-top: 15px"> -->
                <div style="padding: 0 10px 20px;">
                    <el-row class="title_row">
                        <el-col>
                            <span class="title_class">信息筛选</span>
                        </el-col>
                    </el-row>
                    <el-form
                        :model="queryForm"
                        class="filter_Form"
                        label-width="70px"
                        ref="queryFormRef"
                    >
                        <el-row :gutter="50">
                            <el-col :span="6">
                                <el-form-item label="赛季" prop="season">
                                    <el-select
                                        placeholder="请选择赛季"
                                        style="width: 100%"
                                        v-model="queryForm.season"
                                    >
                                        <el-option
                                            v-for="item in dict_season"
                                            :key="item.dictCode"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="所属赛区" prop="districtId">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.districtId"
                                        clearable
                                    >
                                        <el-option
                                            v-for="item in dict_district"
                                            :key="item.id"
                                            :label="item.districtName"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否缴费" prop="userName">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.payd"
                                    >
                                        <el-option
                                            v-for="item in boolData"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="审核状态" prop="status">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.status"
                                    >
                                        <el-option label="待审核" :value="0"></el-option>
                                        <el-option label="需遴选" :value="1"></el-option>
                                        <el-option label="审核通过" :value="2"></el-option>
                                        <el-option label="审核驳回" :value="3"></el-option>
                                        <el-option label="遴选未通过" :value="4"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="姓名" prop="userName">
                                    <el-input
                                        v-model="queryForm.userName"
                                        placeholder="请输入"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="手机号" prop="userPhone">
                                    <el-input
                                        v-model="queryForm.userPhone"
                                        placeholder="请输入"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" align="right">
                                <el-button
                                    type="primary"
                                    @click="getCampList"
                                    >查询</el-button
                                >
                                <el-button
                                    type="primary"
                                    plain
                                    @click="queryReset"
                                    >重置</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div style="padding: 0 10px">
                <!-- </el-card>
                <el-card style="margin-top: 15px"> -->
                    <el-row class="title_row">
                        <el-col :span="12">
                            <span class="title_class">报名信息</span>
                        </el-col>
                        <el-col :span="12">
                            <div style="text-align: right">
                                <!-- <el-button
                                    type="success"
                                    size="small"
                                    @click="addInfoDialog = true"
                                    icon="el-icon-circle-plus-outline"
                                    >新增成员</el-button
                                > -->
                                <el-button
                                    type="primary"
                                    @click="campUserExport"
                                    >导出成员</el-button
                                >
                            </div>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="campUserList"
                        header-cell-class-name="tableHeaderStyle"
                        border
                        stripe
                    >
                        <el-table-column label="#" type="index"></el-table-column>
                        <el-table-column label="赛季" prop="season"></el-table-column>
                        <el-table-column label="赛区" prop="districtName"></el-table-column>
                        <el-table-column label="姓名" prop="userName"></el-table-column>
                        <el-table-column label="小程序账号" prop="userPhone" width="100px"></el-table-column>
                        <el-table-column label="学校省市区" prop="province" width="100px">
                            <template slot-scope="scope">
                                {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.area }}
                            </template>
                        </el-table-column>
                        <el-table-column label="学校" prop="schoolName" width="120px"></el-table-column>
                        <el-table-column label="年级" prop="grade" :formatter="gradeFormat"></el-table-column>
                        <el-table-column label="审核状态" prop="status" width="120px">
                          <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.status === 0 ? 'info' : scope.row.status === 1 ? '' : scope.row.status === 2 ? 'success' : scope.row.status === 3 ? 'danger' : scope.row.status === 4 ? 'warning' : ''">
                              {{ scope.row.status === 0 ? '待审核' : scope.row.status === 1 ? '需遴选' : scope.row.status === 2 ? '审核通过' : scope.row.status === 3 ? '审核驳回' : scope.row.status === 4 ? '遴选未通过' : '' }}
                            </el-tag>
                          </template>
                        </el-table-column>
                         <el-table-column label="遴选作答" prop="matchResultStatus">
                          <template slot-scope="scope">
                            <el-tag size="mini" type="success" v-if="scope.row.matchResultStatus">已作答</el-tag>
                          </template>
                        </el-table-column>
                        <el-table-column label="是否缴费" prop="payd">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.payd"
                                    size="mini"
                                    >已缴费</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">未缴费</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="缴费金额" prop="orderAmount">
                            <template slot-scope="scope">
                                <span style="color: red" v-if="scope.row.payd"
                                    >￥{{ scope.row.orderAmount }}</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="近三年是否参加过国赛" prop="spbcn" width="100px">
                            <template slot-scope="scope">
                                {{ scope.row.spbcn === undefined ? '' : scope.row.spbcn ? '是' : '否' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="是否有其他英语学科标化类考试成绩" prop="otherStandardized" width="100px">
                            <template slot-scope="scope">
                              <div>
                                {{ scope.row.otherStandardized === undefined ? '' : scope.row.otherStandardized ? '是' : '否' }}
                              </div>
                              <div class="textarea">
                                {{ scope.row.otherStandardizedMessage }}
                              </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="证书" prop="files" width="130px">
                            <template slot-scope="scope">
                                <el-image v-if="scope.row.files"
                                    class="files"
                                    :src="scope.row.files"
                                    :preview-src-list="[scope.row.files]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否报名【精英班】遴选" prop="elite" width="100px">
                            <template slot-scope="scope">
                                {{ scope.row.elite === undefined ? '' : scope.row.elite ? '是' : '否' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="年龄" prop="age"></el-table-column>
                        <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
                        <el-table-column label="家长联系方式" prop="phone1" width="100px">
                            <template slot-scope="scope">
                                <div>
                                    {{ scope.row.phone1 }}
                                </div>
                                <div>
                                    {{ scope.row.phone2 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="邮箱" prop="email"></el-table-column>
                        <el-table-column label="Offer" prop="offer" width="130px">
                            <template slot-scope="scope">
                                <el-image v-if="scope.row.offerFile"
                                    class="files"
                                    :src="scope.row.offerFile"
                                    :preview-src-list="[scope.row.offerFile]">
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="订单号"
                            prop="orderNo"
                        ></el-table-column>
                        <!-- <el-table-column label="是否入营测试" prop="trial">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.trial === true"
                                    size="mini"
                                    >已测试</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">未测试</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否签合同(协议)" prop="contract">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.contract === true"
                                    size="mini"
                                    >已签署</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">未签署</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="备注" prop="note"></el-table-column>
                        <el-table-column label="操作" width="80px" fixed="right">
                            <template scope="scope">
                                <el-button
                                    type="text"
                                    icon="el-icon-edit"
                                    size="small"
                                    :disabled="scope.row.payd"
                                    @click="auditFn(scope.row)"
                                    >审核</el-button
                                >
                                <!-- <el-button
                                    type="text"
                                    icon="el-icon-delete"
                                    size="small"
                                    @click="showDeleteCampTip(scope.row.id)"
                                    >删除</el-button
                                > -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryForm.pageNum"
                        :page-sizes="[10, 20, 40, 80]"
                        :page-size="queryForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        v-if="campUserList.length > 0"
                    >
                    </el-pagination>
                <!-- </el-card> -->
                </div>
            </el-tab-pane>
            <el-tab-pane label="遴选测评信息" name="1">
                <gcsccCode ref="codeRef"></gcsccCode>
            </el-tab-pane>
        </el-tabs>
        <!-- 审核 -->
        <el-dialog
            title="报名注册信息审核"
            :visible.sync="visible"
            width="500px"
            @close="visible = false"
        >
            <el-form
                :model="auditForm"
                label-width="100px"
                ref="auditFormRef"
                style="width: 100%"
            >
                <el-form-item label="审核" prop="">
                    <el-select
                        placeholder="请选择"
                        style="width: 100%"
                        v-model="auditForm.status"
                    >
                        <!-- <el-option label="待审核" :value="0"></el-option> -->
                        <el-option label="需遴选" :value="1"></el-option>
                        <el-option label="通过" :value="2"></el-option>
                        <el-option label="驳回" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="note">
                    <el-input
                        v-model="auditForm.note"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveAudit"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
        <el-dialog
            title="添加营员信息"
            :visible.sync="addInfoDialog"
            width="50%"
            @close="handleCloseDialog"
        >
            <el-form
                :model="addInfoModel"
                label-width="100px"
                ref="addInfoFormRef"
                :rules="addInfoRules"
                style="width: 100%"
            >
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="营员姓名" prop="userName">
                            <el-input
                                v-model="addInfoModel.userName"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="userPhone">
                            <el-input
                                v-model="addInfoModel.userPhone"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="所属赛区" prop="districtId">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.districtId"
                                @change="districChange($event, dict_district)"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict_district"
                                    :key="item.id"
                                    :label="item.districtName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学校" prop="schoolId">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.schoolId"
                                @change="schoolChange($event, provincesSchoolList)"
                                clearable
                            >
                                <el-option
                                    v-for="item in provincesSchoolList"
                                    :key="item.id"
                                    :label="item.schoolName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否入营测试" prop="trial">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.trial"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="测试时间" prop="trialTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.trialTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否缴费" prop="payd">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.payd"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="缴费时间" prop="paydTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.paydTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否签署协议" prop="contract">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.contract"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="签署时间" prop="contractTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.contractTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="订单号" prop="orderNo">
                            <el-input
                                v-model="addInfoModel.orderNo"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注" prop="note">
                            <el-input
                                v-model="addInfoModel.note"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="缴费凭证" prop="paymentVoucherUrl">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadImageResults.uploadUrl"
                                :show-file-list="false"
                                :on-success="uploadCoverImgSuccess"
                                :headers="uploadImageResults.headerObj"
                                :data="{
                                    filePath:
                                        'spbcnapp/camp/paymentVoucherImg/',
                                }"
                            >
                                <img
                                    v-if="addInfoModel.paymentVoucherUrl"
                                    class="img-cover"
                                    :src="addInfoModel.paymentVoucherUrl"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addCampersClick"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getAllSchoolList, gcsccGetList, campUserDel, campUserInsert, campUserEdit, queryDistrictPage } from '@/http/api'
import gcsccCode from './gcscc-code.vue'

export default {
  components: {
    gcsccCode
  },
  data () {
    return {
      activeName: '2',
      uploadImageResults: {
        uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      dict_district: [],
      dict_grade: this.$userInfo.getGradeData(),
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      addInfoDialog: false,
      addInfoModel: {
        campId: this.$route.query.campId,
        userPhone: '',
        schoolId: null,
        userName: '',
        districtId: null,
        trial: null,
        trialTime: '',
        payd: null,
        paydTime: '',
        orderNo: '',
        note: '',
        contractTime: '',
        contract: ''
      },
      addInfoRules: {
        userName: [{ required: true, message: '请输入', trigger: 'blur' }],
        userPhone: [{ required: true, message: '请输入', trigger: 'blur' }],
        schoolId: [{ required: true, message: '请选择', trigger: 'change' }],
        districtId: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      boolData: this.$userInfo.dict_boolData(),
      queryForm: {
        // campId: this.$route.query.campId,
        payd: '',
        status: '',
        pageNum: 1,
        pageSize: 10,
        userName: '',
        userPhone: '',
        districtId: null,
        season: this.$chnEngStatusCode.defaultSeason
      },
      total: 0,
      provincesSchoolList: [],
      campUserList: [],
      auditForm: {
        id: '',
        status: '',
        note: ''
      },
      visible: false
    }
  },
  created () {
    this.getDataRequest()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    handleToClick () {
      if (this.activeName === '1') {
        this.$refs.codeRef.getDistrictList()
      } else {
        this.getDataRequest()
      }
    },
    getDataRequest () {
      const promises = [
        this.getAllSchoolList(),
        this.getDistrictList(),
        this.getCampList()
      ]
      Promise.all(promises)
        .then(() => {
        // 执行后续操作
        })
        .catch((error) => {
          console.error('有一个请求失败了', error)
          this.$confirm('基础数据请求失败, 是否刷新?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.getDataRequest()
          }).catch(() => {
          })
        })
    },
    sexFormat (data) {
      return Number(data.sex) === 0 ? '女' : Number(data.sex) === 1 ? '男' : ''
    },
    gradeFormat (data) {
      return data.grade ? this.dict_grade.find(item => item.dictValue === data.grade).dictLabel : ''
    },
    // 获取全部学校list
    getAllSchoolList () {
      getAllSchoolList({}).then((res) => {
        this.provincesSchoolList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    getCampList () {
      console.log('queryForm', this.queryForm)
      gcsccGetList(this.queryForm).then((res) => {
        this.campUserList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getCampList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getCampList()
    },
    queryReset () {
      this.queryForm.payd = ''
      this.$refs.queryFormRef.resetFields()
      this.getCampList()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 营员点击事件
    addCampersClick () {
      if (this.addInfoModel.id) {
        campUserEdit(this.addInfoModel).then((res) => {
          this.$message.success('保存成功')
          this.$refs.addInfoFormRef.resetFields()
          this.addInfoDialog = false
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      } else {
        campUserInsert(this.addInfoModel).then((res) => {
          this.$message.success('添加成功')
          this.$refs.addInfoFormRef.resetFields()
          this.addInfoDialog = false
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      }
    },
    // 编辑成员信息
    editCampDetail (rowData) {
      this.addInfoModel = JSON.parse(JSON.stringify(rowData))
      this.addInfoDialog = true
    },
    uploadCoverImgSuccess (res) {
      console.log('res', res)
      this.$set(this.addInfoModel, 'paymentVoucherUrl', res.data)
    },
    // 导出营员
    campUserExport () {
      var downLoadUrl = this.$http.defaults.baseURL + 'gcsccCampUser/export'
      var formData = JSON.parse(JSON.stringify(this.queryForm))
      formData.pageSize = 1000
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', formData)
    },
    handleCloseDialog () {
    },
    showDeleteCampTip (id) {
      this.$confirm('此操作将删除该营地成员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        campUserDel(id).then((res) => {
          this.$message.success('删除成功')
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      }).catch(() => { })
    },
    districChange (selectedId, districtList) {
      const selectedOption = districtList.find(item => item.id === selectedId)
      if (selectedOption) {
        // 可以在这里进行其他操作，比如将 id 和 districtName 存储到其他变量或对象中
        this.addInfoModel.districtName = selectedOption.districtName
      }
    },
    schoolChange (selectedId, allSchoolList) {
      const selectedOption = allSchoolList.find(item => item.id === selectedId)
      if (selectedOption) {
        // 可以在这里进行其他操作，比如将 id 和 districtName 存储到其他变量或对象中
        this.addInfoModel.schoolName = selectedOption.schoolName
      }
    },
    // gcsccCampUser/review
    auditFn (item) {
      this.visible = true
      this.auditForm.status = ''
      this.auditForm.note = ''
      this.auditForm.id = item.id
    },
    saveAudit () {
      if (!this.auditForm.status) return
      this.$http.post('gcsccCampUser/review', this.auditForm).then(res => {
        if (res.code === 200) {
          this.visible = false
          this.getCampList()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.button-right {
    margin-left: 20px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}
.img-cover {
    width: 120px;
    display: block;
}
.files{
    height: auto;
    width: 100px;
}
.textarea{
  white-space: pre-line;
  max-height: 80px;
  overflow-y: auto;
}
</style>
